import React from 'react';
import { Message } from 'botframework-directlinejs';
import { OutputCard } from '@fluentai/react-copilot';
import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { useBaseMessageStyles } from './use-base-message-styles';
import { MessageActivityClassName } from '../../utils';

export interface IBaseMessageProps {
  message?: Message;
  className?: string;
  isAIMessage?: boolean;
  footer?: React.ReactNode;
  children?: React.ReactNode;
  action?: React.ReactNode;
}

const useOutputSidecarContentStyles = makeStyles({
  root: {
    color: tokens.colorNeutralForeground1,
  },
});

const OutputSidecarContent: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const styles = useOutputSidecarContentStyles();
  return <div className={styles.root}>{children}</div>;
};

export const BaseMessage: React.FC<IBaseMessageProps> = React.memo(({
  className, footer, children, action,
}) => {
  const styles = useBaseMessageStyles();
  return (
    <OutputCard mode="sidecar" className={mergeClasses(MessageActivityClassName, className, styles.root)}>
      <OutputSidecarContent>
        {children}
        <div className={mergeClasses(styles.actions, 'actions')}>
          {action}
        </div>
      </OutputSidecarContent>
      {footer}
    </OutputCard>
  );
});

BaseMessage.defaultProps = {
  className: '',
  isAIMessage: true,
  footer: null,
  children: null,
  message: undefined,
};
